import { loggerCreate } from '@blaze-shared/logger-util';

export const logPageLayout = loggerCreate('page_layout', 'info', null, null);
export const logPageLayoutWarn = loggerCreate('page_layout', 'warn', null, null);
